import { createSlice } from '@reduxjs/toolkit';

export const isInNativeApp = createSlice({
  name: 'isInNativeApp',
  initialState: {
    data: false,
  },

  reducers: {
    setIsInNativeApp: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setIsInNativeApp } = isInNativeApp.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getIsInNativeApp = (state) => {
  return state.isInNativeApp.data;
};

export default isInNativeApp.reducer;
